/* eslint-disable no-shadow */
import {APP_ROUTES_KEYS, APP_ROUTES_TO_URL, DISCOUNT_ROUTE, PRODUCT_BASE_ROUTE} from 'core/modules/routing/constants';

export const GTM_SRC_URL = 'https://www.googletagmanager.com/gtm.js';

export const EventNames = {
    OWOX: 'OWOX',
};

// TODO: Нужны пояснения от аналитика по возможным значениям
export const ProductAvailabilityType = {
    Available: 'available',
    NotAvailable: 'not-available',
};

export const EventCategory = {
    Conversions: 'Conversions',
    Interactions: 'Interactions',
    NonInteractions: 'Non-Interactions',
    AbHeaderWinery: 'ab_header_winery',
    Search: 'Search',
};

export const EventAction: Record<string, string> = {
    Start: 'start',
    Add: 'add',
    PageView: 'page_view',
    Show: 'show',
    Click: 'click',
    AddFilter: 'add_filter',
    RemoveFilter: 'remove_filter',
    RemoveAllFilters: 'removeAll_filter',
    Switch: 'switch',
    Error: 'error',
    Remove: 'remove',
    Close: 'close',
    SearchError: 'SearchError',
    View: 'view',
    GoTo: 'goTo',
    Set: 'set',
    SignOut: 'sign_out',
    SearchActivate: 'SearchActivate',
    SearchTermHistoryClick: 'SearchTermHistoryClick',
    SearchTermSuggestClick: 'SearchTermSuggestClick',
    SearchSuggestClick: 'SearchSuggestClick',
    SearchSuggestAdd: 'SearchSuggestAdd',
    SearchResult: 'SearchResult',
};

export const EventLabel = {
    Comment: 'comment',
    Wishlist: 'wishlist',
    Filter: 'filter',
    Sort: 'sortType',
    Article: 'article',
    Banner: 'banner',
    PriveCard: 'priveCard',
    Products: 'products',
    Product: 'product',
    SearchActivate: 'SearchActivate',
    SearchTermSuggestClick: 'SearchTermSuggestClick',
    SearchTermHistoryClick: 'SearchTermHistoryClick',
    SearchSuggestClick: 'SearchSuggestClick',
    SearchSuggestAdd: 'SearchSuggestAdd',
    SearchResult: 'SearchResult',
    TabFilter: 'tab_filter',
    ProductReview: 'product | review',
    ProductShield: 'product | shield',
    ProductCatalog: 'product | catalog',
    Cart: 'cart',
};

export const EventUserAuth = {
    Auth: '1',
    NotAuth: '0',
};

export const EventPortalName = {
    Product: 'Product',
    ProductReview: 'Product_Review',
    Shop: 'Shop',
    Promotions: 'Promotions',
    Brand: 'Brandd',
    WineshopList: 'VinothequeList',
    Wineshop: 'Vinotheque',
    Articles: 'ArticlesList_All',
    Article: 'Article',
};

export const EventContextType = {
    ProductPage: 'Product_Page',
    ProductReview: 'Product_Review',
    FilterLeftSide: 'filter side',
    FilterTopSide: 'filter top',
    TabFilter: 'tab_filter',
};

export const EventCurrencyCodes = {
    RUB: 'RUB',
};

export const EventListName = {
    SearchRecommendations: 'поисковая подсказка - рекомендуем',
};

export const OWOX_PAGES = {
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.articles]}/[category]/[articleX]`]: 'ARTICLE_PAGE',
    [`/${APP_ROUTES_KEYS.brands}/[...slug]`]: 'BRAND_PAGE',
    CART: 'CART',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.articles]}`]: 'CATALOG_ARTICLES',
    [`/${APP_ROUTES_KEYS.brands}`]: 'CATALOG_BRANDS',
    CATALOG_EVENTS: '',

    // акции
    [`${DISCOUNT_ROUTE}/[[...slug]]`]: 'CATALOG_PROMO',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.stock]}/[...slug]`]: 'PROMO_PAGE',

    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/[...slug]`]: 'CATALOG_SHOP',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.addresses]}`]: 'CATALOG_VINOTHEQUE',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.addresses]}/[code]`]: 'VINOTHEQUE_PAGE',
    CHECKOUT: 'CHECKOUT',
    CORP: 'CORP',
    ERROR_PAGE: 'ERROR_PAGE',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.events]}`]: 'CATALOG_EVENTS',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.events]}/[slug]`]: 'EVENT_PAGE',
    GLASS_RENT: 'GLASS_RENT',
    INFO: 'INFO',
    ['/']: 'MAIN',
    PRIVE: 'PRIVE',
    [`${PRODUCT_BASE_ROUTE}[code]`]: 'PRODUCT_PAGE',
    [`${PRODUCT_BASE_ROUTE}[code]/reviews`]: 'PRODUCT_REVIEWS',
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.personal]}`]: 'PROFILE',

    // поиск
    [`${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.search]}/[[...slug]]`]: 'SEARCH',

    TYP: 'TYP',
} as const;

export type TOwoxPage = (typeof OWOX_PAGES)[keyof typeof OWOX_PAGES];

export const AUTH_GTAG_EVENTS = {
    EMAIL_CLICK: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'ClickEmail',
        eventLabel: 'goToEmailForm',
    },
    EMAIL_FORM_SHOW: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'authForm',
        eventLabel: 'enterEmailPass',
    },
    EMAIL_FORM_CORRECT_EMAIL_PASS: {
        event: 'OWOX',
        eventCategory: 'Interactions',
        eventAction: 'enterEmailPass',
        eventLabel: 'authSuccess',
    },
    PHONE_FORM_SHOW: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'authForm',
        eventLabel: 'enterPhone',
    },
    PASSWORD_FORGOT_CLICK: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'ClickForgotPassword',
        eventLabel: 'goToForgotPassword',
    },
    RESEND_SMS_CODE_CLICK: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'clickButton',
        eventLabel: 'sendCodeAgain',
    },
    SHOW_SMS_CODE_EMAIL: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'recForm',
        eventLabel: 'enterEmailCode',
    },
    SHOW_SMS_CODE_PHONE: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'authForm',
        eventLabel: 'enterPhoneCode',
    },
    SEND_FORGOT_EMAIL_CLICK: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'clickButton',
        eventLabel: 'sendEmail',
    },
    BACK_CLICK: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'clickButton',
        eventLabel: 'backToAuthorization',
    },
    REG_SUCCESS: {
        event: 'OWOX',
        eventCategory: 'Interactions',
        eventAction: 'goToLogin',
        eventLabel: 'registrationSuccesses',
    },
    AUTH_SUCCESS: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'goToLogin',
        eventLabel: 'authorizationSuccesses',
    },
    AUTH_ERROR: {
        eventCategory: 'Non-Interactions',
        event: 'OWOX',
        eventAction: 'error',
        eventLabel: 'errorRegistration',
    },
    WRONG_CODE_PHONE: {
        eventCategory: 'Interactions',
        event: 'OWOX',
        eventAction: 'enterPhoneCodeError',
        eventLabel: 'wrongCode',
    },
    WRONG_CODE_EMAIL: {
        event: 'OWOX',
        eventCategory: 'Interactions',
        eventAction: 'enterEmailCodeError',
        eventLabel: 'wrongCode',
    },
    CODE_ERROR: {
        eventCategory: 'Non-Interactions',
        event: 'OWOX',
        eventAction: 'error',
        eventLabel: 'errorEnterCode',
    },
    WRONG_EMAIL_PASS: {
        event: 'OWOX',
        eventCategory: 'Interactions',
        eventAction: 'authErrorEmailPass',
        eventLabel: 'wrongEmailPass',
    },
} as const;
